export const formatScale = (num) => {
    return `1 : ${num.toLocaleString('cs')}`;
};
export const thousandSeparator = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};
//# sourceMappingURL=utils.js.map